import { Card, CardBody, Col, Row } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { OneSidePaddingTitle, PaddingTitle } from "../../../../Constants/Constants";
import { OneSidePaddingData, OneSidePaddingSubTitle } from "../../../../Data/UiKits/HelperClasses";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const OneSidePadding=()=> {
  return (
    <Col xl="12">
      <Card className="height-equal">
        <CommonCardHeader title={OneSidePaddingTitle} span={OneSidePaddingSubTitle} />
        <CardBody>
          <Row className="g-3">
            {OneSidePaddingData.map((item) => (
              <Col xxl="3" sm="6" key={item.id}>
                <div className="border-wrapper h-100 alert-light-light dark-helper">
                  <H6 className="mb-3">
                    {PaddingTitle} {item.title}
                  </H6>
                  <div className="common-p-box">
                    {item.box.map((padding) => (
                      <span key={padding.id}>{`.p-${padding.text}`}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
}
export default OneSidePadding